import React from 'react';
import styled from 'styled-components';

// --- STYLED COMPONENTS (Aligned with Services page) ---

// Consistent Page Header with background image and overlay
const PageHeader = styled.div`
    /* TODO: Replace with a relevant banner image for the About page */
    background-image: linear-gradient(rgba(42, 125, 225, 0.7), rgba(42, 125, 225, 0.7)), url('/about-us-banner-2.png');
    background-size: cover;
    background-position: center;
    padding: 12rem 2rem;
    text-align: center;
    position: relative;
`;

// Consistent Page Title style
const PageTitle = styled.h1`
    font-size: 3rem;
    color: #fff;
    margin-bottom: 1rem;
`;

// Consistent Page Subtitle style
const PageSubtitle = styled.p`
    font-size: 1.2rem;
    color: #fff;
    max-width: 600px;
    margin: 0 auto;
`;

// Main container for the content sections
const ContentContainer = styled.section`
    padding: 4rem 2rem;
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 4rem; // Space between content cards
`;

// Card layout for each section (similar to ServiceCard)
const InfoCard = styled.div`
    display: flex;
    align-items: center;
    gap: 2.5rem;
    background-color: #fff;
    padding: 2.5rem; /* Increased padding slightly for a more spacious feel */
    border-radius: 10px;
    box-shadow: 0 5px 20px rgba(0,0,0,0.07);

    // Creates the alternating image/text layout
    &:nth-child(odd) {
        flex-direction: row-reverse;
    }

    // Responsive behavior for mobile
    @media (max-width: 768px) {
        flex-direction: column !important;
        text-align: center;
        padding: 2rem;
    }
`;

const ImageContainer = styled.div`
    flex: 1;
    min-width: 300px;

    img {
        width: 100%;
        border-radius: 8px;
        display: block;
    }
`;

const TextContainer = styled.div`
    flex: 1.5;
`;

// Consistent styling for section titles within cards
const CardTitle = styled.h2`
    font-size: 2rem;
    color: #2a7de1;
    margin-bottom: 1rem;
`;

// Consistent styling for section descriptions
const CardText = styled.p`
    font-size: 1.1rem;
    line-height: 1.7;
    color: #444;
`;

// --- REACT COMPONENT ---

const About = () => {
    return (
        <>
            <PageHeader>
                <PageTitle>Our Mission & Approach</PageTitle>
                <PageSubtitle>Building a brighter future for every child through compassionate, connection-focused ABA therapy.</PageSubtitle>
            </PageHeader>

            <ContentContainer>
                {/* Our Philosophy Section */}
                <InfoCard>
                    <ImageContainer>
                        {/* TODO: Replace with a relevant, high-quality image */}
                        <img src="/about-page-philosophy.png" alt="Therapist and child connecting during a session" />
                    </ImageContainer>
                    <TextContainer>
                        <CardTitle>Our Philosophy</CardTitle>
                        <CardText>
                            At BeFriend Therapy, we believe meaningful progress happens when a child feels safe, understood, and connected. Our relationship-based model places friendship and trust at the core of our ABA therapy. We don't just teach skills; we build confidence and foster genuine connections that empower children to navigate their world with joy and independence.
                        </CardText>
                    </TextContainer>
                </InfoCard>

                {/* Our Staff Section */}
                <InfoCard>
                    <ImageContainer>
                        <img src="/bacb-logo.png" alt="The friendly and professional BeFriend Therapy team" />
                    </ImageContainer>
                    <TextContainer>
                        <CardTitle>Our Professional Staff</CardTitle>
                        <CardText>
                            Our team is a dedicated group of Board Certified Behavior Analysts (BCBAs) and Registered Behavior Technicians (RBTs) who are passionate about making a difference. Each member is chosen not only for their expertise but for their empathy and ability to connect with children on a personal level. We are partners, advocates, and friends.
                        </CardText>
                    </TextContainer>
                </InfoCard>

                {/* Your Opportunity Section */}
                <InfoCard>
                    <ImageContainer>
                        <img src="/about-your-opportunity.png" alt="Your Opportunity" />
                    </ImageContainer>
                    <TextContainer>
                        <CardTitle>Your Opportunity</CardTitle>
                        <CardText>
                            You have the opportunity to provide your child with the essential tools they need to thrive. Our evidence-based ABA therapy is designed to build critical life skills—from clear communication and social understanding to daily routines and self-confidence. We focus on turning everyday challenges into moments of growth, empowering your child to navigate their world with greater ease and achieve milestones that create a lifetime of success.
                        </CardText>
                    </TextContainer>
                </InfoCard>
            </ContentContainer>
        </>
    );
};

export default About;